import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { BankConnection } from '@klopotun/contracts';
import { disconnectBank } from '../requests/disconnect-bank.js';
import { refreshBankAndCards } from './bank-cache.js';

export const useDisconnectBankMutation = (): UseMutationResult<BankConnection, Error, void> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disconnectBank,
    onSuccess: () => refreshBankAndCards(queryClient),
  });
};
